/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Header from "./Header";
import SideBar from "./SideBar";
import "./Dashboard.scss";
import { Modal, Button, Image, Placeholder, Tab, Tabs, ProgressBar, Card, Row, Col, Form } from "react-bootstrap";import { serverUrl } from "../../serverUrl";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import { QRCodeCanvas } from 'qrcode.react';
import InvoicesTable from "./InvoicesTable";
import { useParams } from "react-router-dom";
import Income from "../../assets/img/salary.png";
import { useGetCompanyPropertyDetailsQuery } from "../app/lib/apiSlice/property/propertySlice.tsx";

export default function Invoicing() {
    const { id } = useParams()
    const [showSidebar, setShowSidebar] = useState(true);
    // get the company details and update the  invoices
    const { data: companyDetails } = useGetCompanyPropertyDetailsQuery()

    const companyKraCompliance = companyDetails?.results[0]?.kra_compliance;

    const [invoicesData, setInvoicesData] = useState({
        category_a: { count: 0, total_amount: 0, invoices: [] },
        category_b: { count: 0, total_amount: 0, invoices: [] },
        category_c: { count: 0, total_amount: 0, invoices: [] }
    });
    const [showModal, setShowModal] = useState(false);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [qrCodeLink, setQrCodeLink] = useState("");
    const accessToken = localStorage.getItem("authTokens");
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;
    const [loadingInvoiceId, setLoadingInvoiceId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(companyKraCompliance === false ? 'category_c' : "category_a");
    const [downloadProgress, setDownloadProgress] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [dateFilter, setDateFilter] = useState({ from: '', to: '' });

    const config = {
        headers: { Authorization: `JWT ${access}` }
    };
    // NEW: State for download filters
    const [downloadFilters, setDownloadFilters] = useState({
        month: '',
        year: new Date().getFullYear().toString()
    });

    useEffect(() => {
        serverUrl.get(`/tenant/download_bulk_pdf_invoice/?apartment_id=${id}`)
            .then((res) => {
                setInvoicesData(res?.data || {
                    category_a: { count: 0, total_amount: 0, invoices: [] },
                    category_b: { count: 0, total_amount: 0, invoices: [] },
                    category_c: { count: 0, total_amount: 0, invoices: [] }
                });
            })
            .catch((err) => {
                console.log(err)
            })
    }, []);

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleViewPDFInvoice = (invoiceId) => {
        setLoadingInvoiceId(invoiceId);
        serverUrl
            .get(`/tenant/generate_pdf_invoice/?invoice_id=${invoiceId}&download=true`, {
                ...config,
                responseType: 'blob'
            })
            .then((res) => {
                const pdfData = res.data;
                const pdfUrl = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
                window.open(pdfUrl, '_blank');
                setLoadingInvoiceId(null);
            })
            .catch((error) => {
                console.log(error);
                setLoadingInvoiceId(null);
            });
    };

    const handleDownloadClick = (category) => {
        setSelectedCategory(category);
        setShowDownloadModal(true);
        setDownloadFilters({
            month: '',
            year: new Date().getFullYear().toString()
        });
    };


    const handleDownloadFilterChange = (e) => {
        const { name, value } = e.target;
        setDownloadFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const confirmBulkDownload = async () => {
        setIsLoading(true);
        setDownloadProgress(0);
        let manualProgressInterval;
        let isDownloadStarted = false;

        try {
            const categoryLetter = selectedCategory.split('_')[1].toUpperCase();

            // NEW: Build query parameters with filters
            const params = new URLSearchParams({
                apartment_id: id,
                download: 'True',
                category: categoryLetter
            });

            // NEW: Add month and year filters if provided
            if (downloadFilters.month) {
                params.append('month', downloadFilters.month.toLowerCase());
            }
            if (downloadFilters.year) {
                params.append('year', downloadFilters.year);
            }

            const endpoint = `/tenant/download_bulk_pdf_invoice/?${params.toString()}`;


            // Start manual progress after 2 seconds if download hasn't started
            const progressTimeout = setTimeout(() => {
                if (!isDownloadStarted) {
                    manualProgressInterval = setInterval(() => {
                        setDownloadProgress(prev => {
                            const newProgress = prev + Math.floor(Math.random() * 5) + 1;
                            return newProgress > 90 ? 90 : newProgress; // Cap at 90% for manual progress
                        });
                    }, 300);
                }
            }, 2000);

            // Use XMLHttpRequest for better progress tracking
            const xhr = new XMLHttpRequest();
            xhr.open('GET', serverUrl.defaults.baseURL + endpoint, true);
            xhr.responseType = 'blob';

            // Track download progress
            xhr.onprogress = (event) => {
                if (!isDownloadStarted) {
                    isDownloadStarted = true;
                    clearTimeout(progressTimeout);
                    if (manualProgressInterval) clearInterval(manualProgressInterval);
                }

                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setDownloadProgress(percentComplete);
                }
            };

            xhr.onload = () => {
                clearTimeout(progressTimeout);
                if (manualProgressInterval) clearInterval(manualProgressInterval);

                if (xhr.status === 200) {
                    // Jump to 100% when download completes
                    setDownloadProgress(100);

                    setTimeout(() => {
                        const blob = xhr.response;
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        let fileName = `invoices_${categoryLetter}`;
                        if (downloadFilters.month) fileName += `_${downloadFilters.month}`;
                        if (downloadFilters.year) fileName += `_${downloadFilters.year}`;
                        fileName += `_${new Date().toISOString().split('T')[0]}.zip`;

                        a.href = url;
                        a.download = fileName;

                        document.body.appendChild(a);
                        a.click();

                        // Clean up
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);

                        toast.success(`Download completed successfully!`);
                        setIsLoading(false);
                    }, 500); // Small delay to show 100% progress
                } else {
                    toast.error(`Download failed: ${xhr.statusText}`);
                    setIsLoading(false);
                }
            };

            xhr.onerror = () => {
                clearTimeout(progressTimeout);
                if (manualProgressInterval) clearInterval(manualProgressInterval);
                toast.error('Error occurred during download');
                setIsLoading(false);
            };

            xhr.send();

        } catch (error) {
            console.error('Download error:', error);
            toast.error(`Download failed: ${error.message}`);
            setIsLoading(false);
        }
    };

    const monthOptions = [
        { value: '', label: 'All Months' },
        { value: 'january', label: 'January' },
        { value: 'february', label: 'February' },
        { value: 'march', label: 'March' },
        { value: 'april', label: 'April' },
        { value: 'may', label: 'May' },
        { value: 'june', label: 'June' },
        { value: 'july', label: 'July' },
        { value: 'august', label: 'August' },
        { value: 'september', label: 'September' },
        { value: 'october', label: 'October' },
        { value: 'november', label: 'November' },
        { value: 'december', label: 'December' }
    ];

    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let i = 0; i < 6; i++) {
        const year = currentYear - i;
        yearOptions.push({ value: year.toString(), label: year.toString() });
    }
    const handleCloseDownloadModal = () => {
        setShowDownloadModal(false);
        setDownloadProgress(0);
    };

    // Table functionalities
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(0);
    };

    const handleDateFilterChange = (e) => {
        const { name, value } = e.target;
        setDateFilter(prev => ({ ...prev, [name]: value }));
        setCurrentPage(0);
    };

    const getFilteredInvoices = (invoices) => {
        let filtered = invoices.filter((item) => {
            const searchableFields = Object.values(item).join(" ").toLowerCase();
            return searchableFields.includes(searchQuery.toLowerCase());
        });
        if (dateFilter.from) {
            filtered = filtered.filter(inv => new Date(inv.invoice_date) >= new Date(dateFilter.from));
        }
        if (dateFilter.to) {
            filtered = filtered.filter(inv => new Date(inv.invoice_date) <= new Date(dateFilter.to));
        }
        return filtered;
    };

    const getPaginatedInvoices = (invoices) => {
        const filtered = getFilteredInvoices(invoices);
        const totalPages = Math.ceil(filtered.length / itemsPerPage);
        const startIndex = currentPage * itemsPerPage;
        const endIndex = currentPage === totalPages - 1 ? filtered.length : startIndex + itemsPerPage;

        return {
            data: filtered.slice(startIndex, endIndex),
            totalPages,
            startIndex,
            endIndex,
            filteredAll: filtered
        };
    };

    const handlePrevPage = () => setCurrentPage(currentPage - 1);
    const handleNextPage = () => setCurrentPage(currentPage + 1);

    const activeInvoices = invoicesData[activeTab]?.invoices || [];
    const { data, totalPages, startIndex, endIndex, filteredAll } = getPaginatedInvoices(activeInvoices);

    return (
        <>
            <div className="">


                <div className="">
                    <div className="container-fluid">
                        {companyKraCompliance === false ? (
                            <></>
                        )
                            :
                            <div className="staticCards d-flex justify-content-start mb-5">

                                <Card className="w-25 occupacy">
                                    <Card.Body>
                                        <Image src={Income} />
                                        <div className="float-left">
                                            <h3 className="fw-bold">Total</h3>
                                            <div className="d-flex mt-2">
                                                {isLoading ? (
                                                    <Placeholder as="p" animation="glow">
                                                        <Placeholder xs={6} />
                                                    </Placeholder>
                                                ) : (

                                                    <div className='d-block'>
                                                        <span className="mb-0">{invoicesData?.totals?.count} Invoice(s)</span>
                                                        <p className="mt-2 text-primary">KSH. {invoicesData?.totals?.amount?.toLocaleString('en-US')}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                                <Card className="w-25 rentDue">
                                    <Card.Body>
                                        <Image src={Income} />
                                        <div className="float-left">
                                            <h3 className="fw-bold">Category A</h3>
                                            <div className="d-flex mt-2">
                                                {isLoading ? (
                                                    <Placeholder as="p" animation="glow">
                                                        <Placeholder xs={6} />
                                                    </Placeholder>
                                                ) : (
                                                    <div className='d-block'>
                                                        <span className="mb-0">{invoicesData?.category_a.count}  Invoice(s)</span>
                                                        <p className="mt-2 text-success">KSH. {invoicesData?.category_a.total_amount?.toLocaleString('en-US')}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                                <Card className="w-25 defaulters">
                                    <Card.Body>
                                        <Image src={Income} />
                                        <div className="float-left">
                                            <h3 className="fw-bold">Category B</h3>
                                            {isLoading ? (
                                                <Placeholder as="p" animation="glow">
                                                    <Placeholder xs={6} />
                                                </Placeholder>
                                            ) : (
                                                <div className='d-block'>
                                                    <span className="mb-0">{invoicesData?.category_b.count}  Invoice(s)</span>
                                                    <p className="mt-2 text-info">KSH. {invoicesData?.category_b.total_amount?.toLocaleString('en-US')}</p>
                                                </div>
                                            )}
                                        </div>
                                    </Card.Body>
                                </Card>






                                <Card className="w-25 income">
                                    <Card.Body>
                                        <Image src={Income} />
                                        <div className="float-left">
                                            <h3 className="fw-bold">Category C</h3>
                                            <div className="d-flex mt-2">
                                                {isLoading ? (
                                                    <Placeholder as="p" animation="glow">
                                                        <Placeholder xs={6} />
                                                    </Placeholder>
                                                ) : (
                                                    <div className='d-block'>
                                                        <span className="mb-0">{invoicesData?.category_c.count}  Invoice(s)</span>
                                                        <p className="mt-2 text-warning">KSH. {invoicesData?.category_c.total_amount?.toLocaleString('en-US')}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>

                            </div>

                        }



                        {/* Download Buttons */}
                        <Card className="shadow-sm border-0">
                            <Card.Body>
                                {companyKraCompliance === false ? (
                                    <Button
                                        variant="outline-warning"
                                        className="py-3 w-25 download-btn"
                                        onClick={() => handleDownloadClick('category_c')}
                                    >
                                        <i className="me-2 bi bi-building fs-4"></i>
                                        <div>
                                            <div>Download Invoices</div>
                                        </div>
                                    </Button>
                                ) : (
                                    <Row>
                                        <Col md={4}>
                                            <Button
                                                variant="outline-success"
                                                className="py-3 w-100 download-btn"
                                                onClick={() => handleDownloadClick('category_a')}
                                            >
                                                <i className="me-2 bi bi-house-door fs-4"></i>
                                                <div>
                                                    <div>Download Category A</div>
                                                </div>
                                            </Button>
                                        </Col>

                                        <Col md={4}>
                                            <Button
                                                variant="outline-primary"
                                                className="py-3 w-100 download-btn"
                                                onClick={() => handleDownloadClick('category_b')}
                                            >
                                                <i className="me-2 bi bi-building fs-4"></i>
                                                <div>
                                                    <div>Download Category B</div>
                                                </div>
                                            </Button>
                                        </Col>

                                        <Col md={4}>
                                            <Button
                                                variant="outline-warning"
                                                className="py-3 w-100 download-btn"
                                                onClick={() => handleDownloadClick('category_c')}
                                            >
                                                <i className="me-2 bi bi-shop fs-4"></i>
                                                <div>
                                                    <div>Download Category C</div>
                                                </div>
                                            </Button>
                                        </Col>
                                    </Row>
                                )}
                            </Card.Body>
                        </Card>


                        {/* Tabs Navigation */}
                        {!companyKraCompliance ? (
                            < Card className="shadow-sm mb-4 border-0" >
                                <Card.Body className="p-0">
                                    <Tabs
                                        activeKey={activeTab}
                                        onSelect={(k) => setActiveTab(k)}
                                        className="nav-tabs-custom"
                                    >


                                        <Tab eventKey="category_c" title={
                                            <span className="d-flex align-items-center">
                                                <i className="me-2 bi bi-shop"></i> All Invoices
                                            </span>
                                        }>
                                            <div className="p-3">
                                                <InvoicesTable
                                                    invoices={data}
                                                    handleViewPDFInvoice={handleViewPDFInvoice}
                                                    loadingInvoiceId={loadingInvoiceId}
                                                    handleSearch={handleSearch}
                                                    searchQuery={searchQuery}
                                                    currentPage={currentPage}
                                                    totalPages={totalPages}
                                                    handlePrevPage={handlePrevPage}
                                                    handleNextPage={handleNextPage}
                                                    startIndex={startIndex}
                                                    endIndex={endIndex}
                                                    invoiceCount={invoicesData?.category_c.count}
                                                    loading={isLoading}
                                                    dateFilter={dateFilter}
                                                    handleDateFilterChange={handleDateFilterChange}
                                                    exportData={filteredAll.length > 0 ? filteredAll : activeInvoices}
                                                />
                                            </div>
                                        </Tab>
                                    </Tabs>
                                </Card.Body>
                            </Card >

                        )
                            :
                            (
                                < Card className="shadow-sm mb-4 border-0" >
                                    <Card.Body className="p-0">
                                        <Tabs
                                            activeKey={activeTab}
                                            onSelect={(k) => setActiveTab(k)}
                                            className="nav-tabs-custom"
                                        >
                                            <Tab eventKey="category_a" title={
                                                <span className="d-flex align-items-center">
                                                    <i className="me-2 bi bi-building"></i> Category A
                                                </span>
                                            }>
                                                <div className="p-3">
                                                    <InvoicesTable
                                                        invoices={data}
                                                        handleViewPDFInvoice={handleViewPDFInvoice}
                                                        loadingInvoiceId={loadingInvoiceId}
                                                        handleSearch={handleSearch}
                                                        searchQuery={searchQuery}
                                                        currentPage={currentPage}
                                                        totalPages={totalPages}
                                                        handlePrevPage={handlePrevPage}
                                                        handleNextPage={handleNextPage}
                                                        startIndex={startIndex}
                                                        endIndex={endIndex}
                                                        invoiceCount={invoicesData?.category_a.count}
                                                        loading={isLoading}
                                                        dateFilter={dateFilter}
                                                        handleDateFilterChange={handleDateFilterChange}
                                                        exportData={filteredAll.length > 0 ? filteredAll : activeInvoices}
                                                    />
                                                </div>
                                            </Tab>
                                            <Tab eventKey="category_b" title={
                                                <span className="d-flex align-items-center">
                                                    <i className="me-2 bi bi-house-door"></i> Category B
                                                </span>
                                            }>
                                                <div className="p-3">
                                                    <InvoicesTable
                                                        invoices={data}
                                                        handleViewPDFInvoice={handleViewPDFInvoice}
                                                        loadingInvoiceId={loadingInvoiceId}
                                                        handleSearch={handleSearch}
                                                        searchQuery={searchQuery}
                                                        currentPage={currentPage}
                                                        totalPages={totalPages}
                                                        handlePrevPage={handlePrevPage}
                                                        handleNextPage={handleNextPage}
                                                        startIndex={startIndex}
                                                        endIndex={endIndex}
                                                        invoiceCount={invoicesData?.category_b.count}
                                                        loading={isLoading}
                                                        dateFilter={dateFilter}
                                                        handleDateFilterChange={handleDateFilterChange}
                                                        exportData={filteredAll.length > 0 ? filteredAll : activeInvoices}
                                                    />
                                                </div>
                                            </Tab>
                                            <Tab eventKey="category_c" title={
                                                <span className="d-flex align-items-center">
                                                    <i className="me-2 bi bi-shop"></i> Category C
                                                </span>
                                            }>
                                                <div className="p-3">
                                                    <InvoicesTable
                                                        invoices={data}
                                                        handleViewPDFInvoice={handleViewPDFInvoice}
                                                        loadingInvoiceId={loadingInvoiceId}
                                                        handleSearch={handleSearch}
                                                        searchQuery={searchQuery}
                                                        currentPage={currentPage}
                                                        totalPages={totalPages}
                                                        handlePrevPage={handlePrevPage}
                                                        handleNextPage={handleNextPage}
                                                        startIndex={startIndex}
                                                        endIndex={endIndex}
                                                        invoiceCount={invoicesData?.category_c.count}
                                                        loading={isLoading}
                                                        dateFilter={dateFilter}
                                                        handleDateFilterChange={handleDateFilterChange}
                                                        exportData={filteredAll.length > 0 ? filteredAll : activeInvoices}
                                                    />
                                                </div>
                                            </Tab>
                                        </Tabs>
                                    </Card.Body>
                                </Card >
                            )
                        }



                    </div >
                </div >

                {/* Download Confirmation Modal */}
                < Modal
                    show={showDownloadModal}
                    onHide={!isLoading ? handleCloseDownloadModal : null
                    }
                    centered
                    backdrop={isLoading ? 'static' : true}
                >
                    <Modal.Header closeButton={!isLoading} className="bg-light">
                        <Modal.Title className="text-primary">
                            <i className="me-2 bi bi-cloud-arrow-down"></i>
                            Download {selectedCategory?.split('_')[1]?.toUpperCase()} Invoices
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        {!isLoading ? (
                            <div className="text-center">
                                <div className="mb-4">
                                    <i className="text-primary bi bi-file-earmark-zip" style={{ fontSize: "3rem" }}></i>
                                    <h5 className="mt-3">Confirm Download</h5>
                                    <p className="text-muted">
                                        This will download all {selectedCategory?.split('_')[1]?.toUpperCase()} invoices as a ZIP file.
                                    </p>


                                    <div className="mb-3 row">
                                        <p>Filter and get the invoices based on specific dates</p>
                                        <div className="col-md-6">
                                            <Form.Group>
                                                <p className="font-bold text-black text-md text-left">Filter by Month</p>
                                                <Form.Select
                                                    name="month"
                                                    value={downloadFilters.month}
                                                    onChange={handleDownloadFilterChange}
                                                >
                                                    {monthOptions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Group>
                                                <p className="font-bold text-black text-md text-left">Filter by Year</p>
                                                <Form.Select
                                                    name="year"
                                                    value={downloadFilters.year}
                                                    onChange={handleDownloadFilterChange}
                                                >
                                                    {yearOptions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-0 alert alert-info">
                                    <i className="me-2 bi bi-info-circle"></i>
                                    Contains {invoicesData[selectedCategory]?.count || 0} invoices totaling KSH. {invoicesData[selectedCategory]?.total_amount?.toLocaleString('en-US') || 0}
                                </div>


                            </div>
                        ) : (
                            <>
                                <div className="position-relative mb-4">
                                    <i className={`bi ${downloadProgress < 100 ? 'bi-cloud-download' : 'bi-check-circle'
                                        } text-primary fs-1`}></i>

                                </div>

                                <ProgressBar
                                    now={downloadProgress}
                                    animated={downloadProgress < 100}
                                    variant={
                                        downloadProgress < 100 ? 'primary' : 'success'
                                    }
                                    striped
                                    className="mb-3"
                                />

                                <h5>
                                    {downloadProgress < 100
                                        ? 'Downloading your files...'
                                        : 'Download complete!'}
                                </h5>
                                <p className="text-muted small">
                                    {downloadProgress < 100
                                        ? 'Please wait while we prepare your invoices'
                                        : 'The file has been sent to your browser'}
                                </p>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="bg-light">
                        {!isLoading ? (
                            <>
                                <Button variant="outline-secondary" onClick={handleCloseDownloadModal}>
                                    Cancel
                                </Button>
                                <Button variant="primary" onClick={confirmBulkDownload}>
                                    <i className="me-2 bi bi-download"></i> Start Download
                                </Button>
                            </>
                        ) : (
                            <Button
                                variant={downloadProgress < 100 ? "secondary" : "success"}
                                onClick={handleCloseDownloadModal}
                                disabled={downloadProgress < 100}
                                className="w-100"
                            >
                                {downloadProgress < 100 ? (
                                    <>
                                        <span className="me-2 spinner-border spinner-border-sm" role="status"></span>
                                        Downloading ({downloadProgress}%)
                                    </>
                                ) : (
                                    <>
                                        <i className="me-2 bi bi-check-circle"></i> Done
                                    </>
                                )}
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal >

            </div >
        </>
    );
}